import { Enum } from 'enumify';

export default class RequestType extends Enum {
    //
}

RequestType.initEnum(['PATCH', 'POST', 'GET', 'DELETE']);
